export default "__VITE_ASSET__BAqlbJxQ__"